import { cn } from '@/lib/utils'
import { type VariantProps, cva } from 'class-variance-authority'
import { forwardRef } from 'react'

const homeParagraphVariants = cva('leading-relaxed', {
  variants: {
    size: {
      sm: 'text-sm',
      base: 'text-base',
      lg: 'text-lg',
    },
    color: {
      primary: 'text-neutral-800',
      secondary: 'text-neutral-600',
      muted: 'text-gray-300',
    },
    align: {
      left: 'text-left',
      center: 'text-center',
    },
  },
  defaultVariants: {
    size: 'lg',
    color: 'secondary',
    align: 'left',
  },
})

export interface HomeParagraphProps
  extends Omit<React.HTMLAttributes<HTMLParagraphElement>, 'color'>,
    VariantProps<typeof homeParagraphVariants> {}

const HomeParagraph = forwardRef<HTMLParagraphElement, HomeParagraphProps>(
  ({ className, size, color, align, children, ...props }, ref) => {
    return (
      <p className={cn(homeParagraphVariants({ size, color, align, className }))} ref={ref} {...props}>
        {children}
      </p>
    )
  },
)

HomeParagraph.displayName = 'HomeParagraph'

export { HomeParagraph, homeParagraphVariants }
